module.exports = __webpack_public_path__ + "static/media/logo.56914b55.png";